import { DEV, host, protocol } from './utils/constants';

export const cacheKey = '/wiki';

// When testing locally using http for non-localhost URL's, the cache is disabled in the browser.
const isHttpDev = DEV && protocol === 'http:' && host !== 'localhost';
const devCache = {
  add: () => Promise.resolve(),
  addAll: () => Promise.resolve(),
  keys: () => Promise.resolve<Request[]>([new Request(cacheKey)]),
  matchAll: () => Promise.resolve([]),
  match: () => Promise.resolve({ json: () => Promise.resolve() } as Response),
  put: () => Promise.resolve(),
  delete: () => Promise.resolve(true),
} satisfies globalThis.Cache;

export const getCache = async (name: string) => {
  if (isHttpDev || typeof window.caches === 'undefined') return devCache;
  return caches.open(name);
};

export const cache = await getCache('app');
